module.exports = __webpack_public_path__ + "static/media/clover.2f0f5b85.svg";